import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const KnowledgeBase: React.FC = () => {
  return (
    <PageTemplate
      title="Knowledge Base"
      description="Manage knowledge base for your AI agents"
    />
  );
};

export default KnowledgeBase;